import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { useCollapse } from 'react-collapsed';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id';
import { Loader } from '../../Elements/Loader';
import { InfoTooltipIcon } from '../../Feedback/InfoTooltipIcon';
import { ActionsWrapper, CardContent, CardSectionContent, CardSectionContentWrapper, CardSectionSubTitle, CardSectionTitle, } from './styles';
/**
 * @deprecated Use Section.Item component instead. CardSection will be removed in a future version.
 *
 * @example
 * // Before (CardSection):
 * <CardSection title="My Section" isOpen={open} handleToggle={() => setOpen(!open)}>
 *   Content
 * </CardSection>
 *
 * // After (Section.Item):
 * <Section.Item title="My Item" expanded={open} onToggle={() => setOpen(!open)}>
 *   Content
 * </Section.Item>
 */
export const CardSection = memo(forwardRef(function CardSection(props, ref) {
    const { id, title, subTitle, tooltip, collapsible, control, actions, isOpen, children, handleToggle, noPadding, isLoading, dataTestId, className, } = props;
    const { getCollapseProps } = useCollapse({
        isExpanded: collapsible ? isOpen : true,
    });
    return (_jsxs(CardContent, { id: id, ref: ref, className: className, "data-testid": dataTestId, children: [title && (_jsxs(CardSectionTitle, { onClick: handleToggle, "data-testid": getDataTestId(title, 'title', 'card-section'), children: [_jsxs("span", { children: [title, tooltip && _jsx(InfoTooltipIcon, { tooltip: tooltip, dataTestId: 'card-section-title-tooltip' })] }), _jsxs(ActionsWrapper, { children: [actions, control] })] })), subTitle && _jsx(CardSectionSubTitle, { children: subTitle }), (children || isLoading) && (_jsx(CardSectionContent, { ...getCollapseProps(), "data-testid": getDataTestId(title ?? 'title', 'content', 'card-section'), children: _jsxs(CardSectionContentWrapper, { noPadding: noPadding, withoutTitle: !title, children: [isLoading && _jsx(Loader, { cover: true }), children] }) }))] }));
}));
